import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const PersonPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default PersonPageLayout;